// pages/Services.js
import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga";

ReactGA.pageview(window.location.pathname + window.location.search);

const Services = () => {
  return (
    <div>
      <Helmet>
        <title>SAWA | Services</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/services" />
      </Helmet>
      <NavBar />
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-white">
        <img
          src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/gnwagxd8d1nynafedabu.webp"
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 z-10"></div>
        <div className="relative z-20 text-center px-4 sm:px-6 lg:px-8" data-aos="fade-up" data-aos-duration="2000">
          <h1 className="text-4xl sm:text-5xl md:text-8xl lg:text-7xl font-semibold mb-4">
            Our Services
          </h1>
          <p className="max-w-lg font-poppins mt-10 sm:max-w-xl md:max-w-2xl lg:max-w-4xl font-light mx-auto text-lg sm:text-xl md:text-2xl">
            From providing a dedicated workspace for your creative endeavors to
            teaching art techniques and preserving your artwork, we have you
            covered. Whether you're looking to rent our studio, take a class,
            frame your masterpiece, or commission a custom piece.
          </p>
        </div>
        <div className="absolute top-0 left-0 w-full h-full border-l-[1px] border-b-[3px] border-white z-30"></div>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4 md:px-12 lg:px-48 py-20">
        <div className="relative overflow-hidden rounded-lg shadow-lg group" data-aos="fade-down" data-aos-duration="500">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/rt1wb1zwcxdo74ge4p6a.webp"
            alt="Art Studio"
            className="w-full h-[520px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-10"></div>
          <div className="absolute bottom-4 left-4 text-gray-50 p-5 z-20" data-aos="fade-in" data-aos-duration="2000">
            <h3 className="text-2xl md:text-4xl lg:text-5xl font-semibold">
              Art Studio <br /> Rental
            </h3>
            <a href="/services/art-studio-rental" className="relative overflow-hidden rounded-lg shadow-lg group">
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                View More
              </button>
            </a>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-lg shadow-lg group" data-aos="fade-down" data-aos-duration="500">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/cjuj5ymeugeclic21gyz.webp"
            alt="Workshops"
            className="w-full h-[520px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-10"></div>
          <div className="absolute bottom-4 left-4 text-gray-50 p-5 z-20" data-aos="fade-in" data-aos-duration="2000">
            <h3 className="text-2xl md:text-4xl lg:text-5xl font-semibold">
              Workshops and Classes
            </h3>
            <a href="/services/workshops-and-classes" className="relative overflow-hidden rounded-lg shadow-lg group">
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                View More
              </button>
            </a>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-lg shadow-lg group" data-aos="fade-down" data-aos-duration="500">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/x4gstfwf1bnca6r0nzcb.webp"
            alt="Framing"
            className="w-full h-[520px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-10"></div>
          <div className="absolute bottom-4 left-4 text-gray-50 p-5 z-20" data-aos="fade-in" data-aos-duration="2000">
            <h3 className="text-2xl md:text-4xl lg:text-5xl font-semibold">
              Framing and Restoration
            </h3>
            <a href="/services/framing-and-restoration" className="relative overflow-hidden rounded-lg shadow-lg group">
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                View More
              </button>
            </a>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-lg shadow-lg group" data-aos="fade-down" data-aos-duration="500">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/gfcitnh7qmtcevvb16hz.webp"
            alt="Commissions"
            className="w-full h-[520px] object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-10"></div>
          <div className="absolute bottom-4 left-4 text-gray-50 p-5 z-20" data-aos="fade-in" data-aos-duration="2000">
            <h3 className="text-2xl md:text-4xl lg:text-5xl font-semibold">
              Commissions
            </h3>
            <a href="/commissions" className="relative overflow-hidden rounded-lg shadow-lg group">
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                View More
              </button>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
